import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { ImageFile } from './imageFile';
import { IColumnModel, ColumnModel } from 'table-editor';
import { ITableColumn, TableColumn, ColumnDataTypes } from 'new-table-editor';

/** Each object of this class describes an imge and the name of a set of images it belongs to. These sets are used, for example, to bind pages of a book or the front/back of a letter.*/
export class BoundImageSet extends StarbaseEntity implements Serializable<BoundImageSet> {
  /** The name of the Set, together with imageModelId, comprise a unique entry for this class. */
  public name: string;
  /** The UID of the ImageFile object linked in this record. */
  public imageModelId: number;
  /** The ImageFile object represented on this record. */
  public imageModel: ImageFile;
  /** The order in which this record will appear in the set. Starts with 0, and there must be a 0. There must not be any duplicate sequence numbers for a set. */
  public sequenceNumber: number;

  constructor(name: string, image: ImageFile, sequence: number) {
    super();
    this.uid = 0;
    this.name = name;
    this.imageModel = image;
    this.imageModelId = image.uid;
    this.sequenceNumber = sequence;
  }

  public static boundImageSetColumnData(editable: boolean = false): IColumnModel[] {
      return [
          new ColumnModel('Image Name', 'name', 'name', false, 'string', false, false, 150, false),
          new ColumnModel('Sequence Num', 'sequenceNumber', 'sequenceNumber', editable, 'number', false, false, 10, false),
          new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, false, 100, false),
          new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, false, 100, false),
      ];
  }

  public static boundImageSetColumns(editable = false, includeSequenceNum = false): ITableColumn[] {
    const nameCol = new TableColumn('name', 'Name', ColumnDataTypes.string, true, editable, true);
    nameCol.sortingColumn = 'Name';
    const sequenceCol = new TableColumn('sequenceNumber', 'Sequence Num', ColumnDataTypes.number, true, editable);
    sequenceCol.sortingColumn = 'SequenceNumber';
    return includeSequenceNum ? [
      nameCol,
      sequenceCol,
      ...TableColumn.generateColumnsForStarbaseEntity(false, false, true)
    ] : [
      nameCol,
      ...TableColumn.generateColumnsForStarbaseEntity(false, false, true)
    ];
  }

  deserialize(input) {
    return Object.assign(new BoundImageSet(input.name, input.image, input.sequence), input);
  }
}
